import { render, staticRenderFns } from "./ContentOrderList.vue?vue&type=template&id=85906956&scoped=true"
import script from "./ContentOrderList.vue?vue&type=script&lang=js"
export * from "./ContentOrderList.vue?vue&type=script&lang=js"
import style0 from "./ContentOrderList.vue?vue&type=style&index=0&id=85906956&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85906956",
  null
  
)

export default component.exports